import images from './images';

const wines = [
  {
    title: 'Foot Facial',
    price: '350 Rs',
  },
  {
    title: 'Shahnaj Shah Life',
    price: '650 Rs',
  },
  {
    title: 'Shahnaj Ayurvedic',
    price: '500 Rs',
  },
  {
    title: 'Shahnaj Purl',
    price: '950 Rs',
  },
  {
    title: 'Shahnaj Oxygen by Machine',
    price: '1100',
  },
  {
    title: 'Shahnaj Gold',
    price: '1100',
  },
  {
    title: 'Shahnaj Diamond',
    price: '1700',
  },
  {
    title: 'Shahnaj Chocalte',
    price: '600',
  },
  {
    title: 'Pigmentation',
    price: '1100',
  },
  {
    title: 'O3 Facial',
    price: '1800',
  },
];

const cocktails = [
  {
    title: 'Striaght Cutting',
    price: '40 Rs',
    // tags: 'Aperol |  Marchesi prosecco | soda | 30 ml',
  },
  {
    title: 'Light-U Cutting ',
    price: '50 Rs',
  },
  {
    title: '3-step Cutting',
    price: '180 Rs',
  },
  {
    title: 'Side Look Cutting',
    price: '140 Rs',
  },
  {
    title: 'Layer Cutting',
    price: '120 Rs & 180 Rs',
  },
  {
    title: 'Advance Cutting ',
    price: '200 Rs',
  },
  {
    title: '3-Step Front Philipes Back',
    price: '180 Rs',
  },
  {
    title: 'Mushroom Cutting',
    price: '120 Rs',
  },
  {
    title: 'Deep U Cutting',
    price: '60 Rs',
  },
  {
    title: 'U-Back Layer Front Cutting',
    price: '80 Rs',
  },
];

const awards = [
  {
    imgUrl: images.award02,
    title: 'abcd',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award01,
    title: 'abcd',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award05,
    title: 'abcd',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award03,
    title: 'abcd',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
];

export default { wines, cocktails, awards };
